export default async function updateTemplate({ commit, rootGetters, dispatch }, { templateId, templateData }) {
    try {
        commit('SET_UPDATE_TEMPLATE_LOADING', true);

        const customer = rootGetters["customer/CUSTOMER"];
        const selected_customer = rootGetters["customer/SELECTED_CUSTOMER"];

        let customer_id = customer.customer_id;
        if (customer_id === 0) {
            customer_id = selected_customer.customer_id;
        }

        const data = {
            ...templateData,
            customer_id,
            id: templateId
        };

        const response = await window.axios.put('/proxy/ai/extract-templates', data);

        if (response.data.success) {
            dispatch('notifications/pushNotification', 'Extract template updated successfully', { root: true });

            commit('SET_TEMPLATE', response.data.data);
        } else {
            dispatch('notifications/setError', 'Failed to update extract template', { root: true });
        }
    } catch (error) {
        console.error('Error updating extract template:', error);
        dispatch('notifications/setError', 'Failed to update extract template', { root: true });
    } finally {
        commit('SET_UPDATE_TEMPLATE_LOADING', false);
    }
}